export default __webpack_public_path__ + "static/char-57-anr-4c65c66f2c727cd87f60964b1e2b25b7.webp";